const CookiesBox = ((($) => {
  function init() {
    $('#cookies-ok').on('click', function(e) {
      e.preventDefault();
      $.cookie('was', true, {
        expires: 7,
        path: '/'
      });
      $(this).parents('#cookiesbanner').fadeOut('fast');
    });

    if (!$.cookie('was')) {
      setTimeout($('#cookiesbanner').css('display', 'block'), 1000);
    }
  }

  return {
    init,
  };
}))(jQuery);


export default CookiesBox;



// WEBPACK FOOTER //
// ./src/static/js/modules/cookies.js